import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import qoute from "../../assets/qoute.svg";
import profile_pic from "../../assets/profile_pic.png";
import testimonialsection2img from "../../assets/testimonialsection2img.png";
import "./testimonialSection2.css";

export default function TestimonialSection2() {
  return (
    <div className="testimonial_section_two_wrapper">
      <div className="left_container_two">
        <p>
          Our <span>Testimonials</span>
        </p>

        <Swiper
         pagination={{
          clickable: true,
        }}
          slidesPerView={1}
          spaceBetween={30}
          // loop={true}
          // autoplay={{
          //   delay: 2500,
          //   disableOnInteraction: false,
          // }}

          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper swiperTestimonial"
        >
          {[1, 1, 1]?.map((item) => {
            return (
              <SwiperSlide>
                <div className="box_container_slider_testimonial_two">
                  <img
                    className="qoute_self"
                    src={qoute}
                    alt="qoute"
                    loading="lazy"
                  />
                  <p>
                    “ Dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua
                    enim ad minim veniam quis nostrud exercitation ullamco
                    laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                    reprehenderit voluptate velit ”
                  </p>

                  <div className="profile_pic_wrapper">
                    <img src={profile_pic} alt="profile_pic" loading="lazy" />
                  </div>

                  <p>
                    Robert Adison/<span>CEO</span>
                  </p>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div className="right_container_two">
        <div className="">
          <img
            src={testimonialsection2img}
            alt="testimonialsection2img"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
